import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/CustomerSupport/ContactUs.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import phone from '../../../Assets/CustomerSupport/Assets-WebApp/phone.svg';
import mail from '../../../Assets/CustomerSupport/Assets-WebApp/mail.svg';

class ContactUs extends Component {
    constructor(props) {
        super(props)
        this.state = {
            EmailData: [
                { emailtype: 'For concerns email us at', email: "complaints@transnet.net" },
                { emailtype: 'For compliments email us at', email: "compliments@transnet.net" },
                { emailtype: 'For queries email us at', email: "tptcallcenter@transnet.net" }
            ],
            phoneNo: '+27 86 120 4485',
        }
    }
    render() {
        return (
            <div class="contactcaacsoutercolor">
                <MetaDecorator title={TitleDescription.contactUsPageTitle} description={TitleDescription.contactUsPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="contactcaacsnofullprepro">
                    <div id="contactcaacsnobox1prepro">
                        <nav class="contactcaacnononavbar">
                            <div className="contactarcaacnonavbarname">
                                <small id="contactnonavc">Contact Us</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="contactarcaanotificationmaincardprepro">
                            <div class="contactusdiv">
                                <div class="contactusdivin">
                                    <div class="contusdivrow">
                                        <div class="contusdivcol1">
                                            <img src={phone} class="" alt="" loading="lazy" />
                                        </div>
                                        <div class="contusdivrowcolup">
                                            <div class="contusdivcol2">
                                                <small class="contusdivcolsmall2">Phone</small>
                                            </div>
                                            <div class="contusdivcol3">
                                                <small class="contusdivcolsmall3">{this.state.phoneNo}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="contusdivrow2">
                                        <div class="contusdivcol1">
                                            <img src={mail} class="" alt="" loading="lazy" />
                                        </div>
                                        <div class="contusdivrowcol2">
                                            <small class="contusdivcolsmall2">Email Us</small>
                                            {(this.state.EmailData?.map((EmailData, index) => {
                                                return (
                                                    <div class="contusdivrowcol3">
                                                        <div class="contusdivrowline1">
                                                            <small class="contusdivrowlinesm1">
                                                                {EmailData?.emailtype}
                                                            </small>
                                                        </div>
                                                        <div class="contusdivrowline2">
                                                            <small class="contusdivrowlinesm2">
                                                                {EmailData?.email}
                                                            </small>
                                                        </div>
                                                    </div>);
                                            }))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="caanotifooter01ahzpreexp">
                    <Footer />
                </div>
                <div class="caanotifooter02ahzpreexp">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default ContactUs;